/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 669:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _defineProperty = __webpack_require__(779);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Module dependencies
 */
var _require = __webpack_require__(308),
  matchPath = _require.matchPath;

/**
 * Match pathname with routes
 * @param {Array} routes
 * @param {String} pathname
 */
module.exports = function () {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var route = null;
  for (var i = 0; i < routes.length; i += 1) {
    if (routes[i].path) {
      var match = matchPath(pathname, routes[i]);
      if (match) {
        var matchParamKeys = Object.keys(match.params);

        // Remove ? from url params
        for (var j = 0; j < matchParamKeys.length; j += 1) {
          if (/\?$/.test(match.params[matchParamKeys[j]])) {
            match.params[matchParamKeys[j]] = match.params[matchParamKeys[j]].replace(/\?$/, '');
            break;
          }
        }
        route = _objectSpread(_objectSpread({}, routes[i]), {}, {
          component: routes[i].component,
          fetchData: routes[i].fetchData || null,
          params: match.params
        });
        break;
      }
    }
  }
  return route;
};

/***/ }),

/***/ 779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 308:
/***/ ((module) => {

"use strict";
module.exports = require("react-router");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(669);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=match.js.map